import { debounce } from 'vue-debounce';
import Api from '@/service/api';
import * as registrationHelper from '@/helpers/registration';

import Input from '@/components/Form/Input/index.vue';
import CodeField from '@/components/Form/CodeField/index.vue';

import {
  REGISTRATION_EMAIL_CODE_EXPIRATION_TIME,
  REGISTRATION_EMAIL_CODE_LENGTH,
} from '@/constants/constants';

export default {
  name: 'CodeVerification',

  props: {
    email: String,
    isCardActivation: Boolean,
    cardNumber: String,
    pinCode: String,
  },

  components: {
    CodeField,
    Input,
  },

  computed: {
    expirationTime() {
      let minutes = Math.floor((this.expirationSeconds) / 60);
      let seconds = this.expirationSeconds - (minutes * 60);

      if (minutes < 10) minutes = `0${minutes}`;
      if (seconds < 10) seconds = `0${seconds}`;

      return `${minutes}:${seconds}`;
    },
  },

  methods: {
    onChangeCode() {
      this.isError = false;
    },

    changeEmail() {
      this.newEmail = this.email;
      this.isChangeEmail = true;
    },

    async checkCode(code) {
      const data = {
        email: this.email,
        lang: this.$i18n.locale,
        validation_code: code,
      };

      if (this.isCardActivation) {
        data.card_number = this.cardNumber.replace(/^0+/, '');
        data.pin_code = this.pinCode;
      }

      this.isCanCheckCode = false;
      try {
        await Api.post({
          url: 'validate-email-code',
          data,
        });
      } catch (error) {
        this.isError = true;
        this.errorCode = error.code;
        this.$refs.code.error();
        this.isCanCheckCode = true;

        return;
      }

      const emailCodeExpirationDate = registrationHelper.getEmailCodeExpirationDate(
        REGISTRATION_EMAIL_CODE_EXPIRATION_TIME,
      );

      registrationHelper.saveEmailCode({
        email: this.email,
        code,
        expires: emailCodeExpirationDate,
      });

      this.$refs.code.success();
      this.isSuccess = true;
      this.isCanCheckCode = true;

      debounce(() => {
        this.$router.push({
          name: 'FillingInformation',
          query: { isCardActivation: 'true' },
        });
      }, 2000)();
    },

    setTimer() {
      const localTimerId = setInterval(
        () => {
          this.expirationSeconds -= 1;

          if (this.expirationSeconds <= 0) {
            this.expirationSeconds = 0;
            clearInterval(localTimerId);
          }
        },
        1000,
      );
    },

    requestNewCode() {
      this.isError = false;
      this.$refs.code.clear();

      if (this.isChangeEmail) {
        this.$emit('changeEmail', this.newEmail);
      } else {
        this.$emit('requestNewCode', this.checkExpirationTime);
      }
    },

    checkExpirationTime() {
      const localData = registrationHelper.getLast();
      this.expirationSeconds = registrationHelper.getExpirationSeconds((new Date(localData.time)));
      this.setTimer();
      this.isChangeEmail = false;
    },

    fieldsChanged() {
      this.validated = true;
      this.isError = false;
    },

    setError(error) {
      this.errorCode = error;
      this.isError = true;
    },
  },

  created() {
    const verificatedEmailData = registrationHelper.getDataToRestore();

    if (verificatedEmailData) {
      this.code = verificatedEmailData.code;
      this.isSuccess = true;
      debounce(() => { this.$router.push('filling-information'); }, 2000)();
    }

    this.checkExpirationTime();
  },

  data() {
    return {
      expirationSeconds: 0,
      errorCode: null,
      validated: this.validated || true,
      isError: false,
      REGISTRATION_EMAIL_CODE_LENGTH,
      isSuccess: false,
      code: null,
      isChangeEmail: false,
      isCanCheckCode: true,
      newEmail: '',
    };
  },
};
